module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conslutant-wrapper is-one-third column"
  }, [_c('div', {
    staticClass: "consultant"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteConsultant(_vm.consultant.id)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "centered switch-wrapper"
  }, [_c('b-switch', {
    on: {
      "change": function($event) {
        return _vm.updateConsultant(_vm.consultant)
      }
    },
    model: {
      value: (_vm.consultant.isHidden),
      callback: function($$v) {
        _vm.$set(_vm.consultant, "isHidden", $$v)
      },
      expression: "consultant.isHidden"
    }
  }, [_vm._v("Скрыть консультанта")])], 1), _vm._v(" "), _c('div', {
    staticClass: "is-flex centered"
  }, [_c('div', {
    staticClass: "rounded-photo-wrapper agency-photo centered",
    style: (_vm.photoContainerStyle)
  }, [_c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  }), _vm._v(" "), (!_vm.consultant.photo) ? _c('div', {
    on: {
      "click": _vm.handleLoadPhoto
    }
  }, [_c('span', [_vm._v("Загрузить фото")])]) : _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteConsultantPhoto(_vm.consultant.id)
      }
    }
  })])]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Имя консультанта "
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Имя консультанта"
    },
    on: {
      "change": function($event) {
        return _vm.updateConsultant(_vm.consultant)
      }
    },
    model: {
      value: (_vm.consultant.name),
      callback: function($$v) {
        _vm.$set(_vm.consultant, "name", $$v)
      },
      expression: "consultant.name"
    }
  })], 1), _vm._v(" "), (_vm.consultant.type === 'common') ? _c('b-field', {
    attrs: {
      "label": "email консультанта"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "email"
    },
    on: {
      "change": function($event) {
        return _vm.updateConsultant(_vm.consultant)
      }
    },
    model: {
      value: (_vm.consultant.email),
      callback: function($$v) {
        _vm.$set(_vm.consultant, "email", $$v)
      },
      expression: "consultant.email"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.consultant.type === 'common') ? _c('b-field', {
    attrs: {
      "label": "телефон консультанта"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "телефон консультанта"
    },
    on: {
      "change": function($event) {
        return _vm.updateConsultant(_vm.consultant)
      }
    },
    model: {
      value: (_vm.consultant.phone),
      callback: function($$v) {
        _vm.$set(_vm.consultant, "phone", $$v)
      },
      expression: "consultant.phone"
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85b9cbc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/Consultant.vue
// module id = 980
// module chunks = 0